import type { ComponentProgressDetailView } from '@/types/coaching'
import type { HandheldSection } from './handheldGrading'

export type ComponentPhotoKey = `component:${string}`
export interface ComponentPhotoTarget {
  key: ComponentPhotoKey
  label: string
}

export const componentPhotoKey = (configComponentId: string): ComponentPhotoKey => `component:${configComponentId}`

/** Photos follow the configured component, including before a progress row exists. */
export function componentGradingSection(component: ComponentProgressDetailView): HandheldSection | null {
  if (component.type === 'buildup') return 'buildup'
  if (component.type === 'video' && component.video?.pauseEnabled) return 'blockQuiz'
  return null
}

export function componentPhotoTargets(section: HandheldSection | 'lessonPhoto' | null, components: ComponentProgressDetailView[]): ComponentPhotoTarget[] {
  if (section == null) return []
  return components.filter(component => componentGradingSection(component) === section)
    .map(component => ({ key: componentPhotoKey(component.configComponentId), label: component.label }))
}
